import './CongratulationsPage.scss';
import { Button, Typography } from '@mui/material';
import AddSpace from '../../UtilityComponents/AddSpace/AddSpace';
import Lottie from 'lottie-react';
import successLottie from '../../../assets/lottie_animations/success-lottie.json';
import Footer from '../Footer/Footer';

interface CongratulationsPageProps {
    needTopSpace?: boolean;
    title: string;
    description: string;
    buttonText: string;
    buttonIcon: JSX.Element;
    onClickHandler: () => void;
}

const CongratulationsPage = ({ title, description, buttonIcon, buttonText, onClickHandler, needTopSpace }: CongratulationsPageProps) => {
        
  return (
    <div className='congratulations-page'>
        {needTopSpace && <AddSpace vSpace={"10vh"} hSpace={"0"} />}
        <div className='main-container'>
            <Lottie className="success-lottie" animationData={successLottie} loop={true}></Lottie>
            <Typography fontSize={50} fontWeight={'bold'} width={"80%"}>
                {title}
            </Typography>

            <Typography fontSize={24} marginTop={'20px'} fontWeight={'regular'} width={"80%"} lineHeight={"1.8rem"}>
                {description}
            </Typography>

            <Button 
            className="action-btn" 
            startIcon={<div className='btn-image-container'>{buttonIcon}</div>} 
            variant='contained' 
            size='large'
            onClick={onClickHandler}>
                {buttonText}
            </Button>
        </div>
        <Footer />
    </div>
  )
}

export default CongratulationsPage